import styled from 'styled-components';

export const ProceedingsCard = styled.a`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: white;
  background-clip: border-box;
  border-radius: 1rem;
  padding: 2rem;
  border: 1px solid var(--color-mono-95);
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: inherit;
  max-width: 64rem;

  &:hover {
    box-shadow: rgb(0 0 0 / 16%) 0px 8px 16px -4px,
      rgb(0 0 0 / 75%) 0px 8px 16px -16px;
    transition: 0.3s border-color, 0.2s box-shadow;
  }
`;
